import { FC } from 'react';

import { Link } from '@inertiajs/react';

import { Card, CardContent } from '../../components/ui/Card';
import { Routes } from '../../models/routes';
import { Order } from '../../types';

interface Props {
    orders: Order[];
    isMultipleOrders: boolean;
    getOrderNumber: (order: Order) => string | number;
}

export const OrderConfirmationHeaderCard: FC<Props> = ({
    orders,
    isMultipleOrders,
    getOrderNumber,
}) => {
    return (
        <Card className="mb-8">
            <CardContent className="pt-8 pb-8 text-center">
                <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 dark:bg-green-500/15">
                    <span className="text-4xl text-green-600 dark:text-green-300">&#10003;</span>
                </div>
                <h2 className="mb-2 text-2xl font-bold text-gray-900 dark:text-foreground">
                    Дякуємо за замовлення!
                </h2>
                <p className="mb-4 text-gray-600 dark:text-muted-foreground">
                    {isMultipleOrders
                        ? `Ваші замовлення (${orders.length}) успішно оформлені і передані в обробку. Продавці зв'яжуться з вами найближчим часом для підтвердження деталей.`
                        : "Ваше замовлення успішно оформлено і передано в обробку. Продавець зв'яжеться з вами найближчим часом для підтвердження деталей."}
                </p>
                <div className="mb-6 rounded-lg bg-gray-50 p-4 dark:bg-muted/50">
                    <p className="mb-2 text-sm text-gray-600 dark:text-foreground">
                        {isMultipleOrders
                            ? 'Номери замовлень:'
                            : 'Номер замовлення:'}
                    </p>
                    <div className="space-y-1">
                        {orders.map((ord) => (
                            <p
                                key={ord.id}
                                className={`${isMultipleOrders ? 'text-lg' : 'text-xl'} font-bold text-gray-900 dark:text-foreground`}
                            >
                                {getOrderNumber(ord)}
                            </p>
                        ))}
                    </div>
                </div>
                <p className="text-sm text-gray-500 dark:text-muted-foreground">
                    Ви можете переглянути статус ваших замовленнь в розділі{' '}
                    <Link
                        href={Routes.Purchases}
                        className="text-blue-600 hover:underline dark:text-primary"
                    >
                        Мої покупки
                    </Link>
                    .
                </p>
            </CardContent>
        </Card>
    );
};
